import { ProfileSettingsPage } from './profile_settings_page'

export const ProfilePage = () => (
  <ProfileSettingsPage />
)
